import React, {useState, useEffect, useRef} from 'react';
import './styles.css';
import '../../assets/styles/styles.css';
import {Link} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {useSelector} from 'react-redux';
import {requestRegionInitiative, setInitiativeClicked, requestSensitiveRegionsInitiatives} from './../../actions/initiativeActions';
import Footer from './../../components/footer/footer';
import {useHistory} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowCircleLeft as arrowLeft} from '@fortawesome/free-solid-svg-icons';
import {faArrowCircleRight as arrowRight} from '@fortawesome/free-solid-svg-icons';

function InitiativeForm1(){

    const history = useHistory();
    const dispatch = useDispatch();
    const inputSensitive = useRef(null);
    const region = useSelector(state => state.initiative.regionClicked);
    const [initiativs, svinitiativs] = useState([]);
    const [requestInitiativesFlag, svrequestInitiativesFlag] = useState(true);
    const [initiativesSensitive, svinitiativesSensitive] = useState([]);
    let sensitiveFindTrigger;
    let validEntry;
    let storageCurrentPage = JSON.parse(localStorage.getItem('currentPageInitiative'));
    storageCurrentPage = storageCurrentPage !== null? storageCurrentPage: 1;
    const [currentPage, svcurrentPage] = useState(storageCurrentPage);
    const [totalPages, svtotalPages] = useState(1);
    const [valueInput, svvalueInput] = useState("");

    const cbRequestInitiatives = (result) => {
        let totalPgs = parseInt(result.headers.totalpage);
        if(currentPage > totalPgs){
            svcurrentPage(totalPgs);
            svrequestInitiativesFlag(true);
        }
        svtotalPages(totalPgs);
        svinitiativs(result.data);
    }

    const initiativeClick = (item) => {
        dispatch(setInitiativeClicked(item));
    }

    const cbRequestSensitive = (data) => {
        svinitiativs(data);
    }

    const inputSelectChange = () => {
        validEntry = true;
        let value = inputSensitive.current.value;
        if(value.length > 0){
            clearInterval(sensitiveFindTrigger);
            sensitiveFindTrigger = setTimeout(() => {
                let data = {
                    termino: value,
                    idMicroRegion: region.id.toString()
                };
                dispatch(requestSensitiveRegionsInitiatives(data, cbRequestSensitive));
            }, 500);
        }else{
            svrequestInitiativesFlag(true);
        }
    }

    const nextPage = (sum) => {
        localStorage.setItem('currentPageInitiative', JSON.stringify(currentPage + sum));
        svcurrentPage(currentPage + sum);
        svrequestInitiativesFlag(true);
    }

    const previousPage = (sum) => {
        localStorage.setItem('currentPageInitiative', JSON.stringify(currentPage + sum));
        svcurrentPage(currentPage + sum);
        svrequestInitiativesFlag(true);
    }

    useEffect(() => {
        if(requestInitiativesFlag === true){
            svinitiativs([]);
            svrequestInitiativesFlag(false);
            let data = {
                params: {
                    page: currentPage,
                    idMicroRegion: region.id.toString()
                }
            };
            dispatch(requestRegionInitiative(data, cbRequestInitiatives));
        }

    }, [requestInitiativesFlag, region.id, dispatch]);

    return (
        <React.Fragment>
            <div className="p-2">
                <div className="row m-0">
                    <Link to={"/iniciativa/"} className="noStyle">
                        <div className="bt-1">Regresar</div>
                    </Link>
                </div>
                <div className="row m-0 justify-content-center mt-3">
                    <div className="contInitiatives">
                        {
                            // <div className="row m-0 md-initiative-buttons">
                            //     {region.url && <a href={region.url} target="_blank" style={{width:180, margin:5}} className="bt-1  activer-info-tag">El Valle Participa</a>}
                            //     <div className="info-tag">aquí puedes ver la galería de imágenes de la participación ciudadana en los talleres</div>
                            //     {/*<div className="bt-1" onClick={() => history.push("/iniciativa/formulario1/galeria/")} style={{width:180, margin:5}}>El Plan de l@s niñ@s</div>*/}
                            // </div>
                        }
                        <div style={{height:10}}></div>
                        <div style={{textAlign:"center", fontWeight:"bold"}}>{`MICRO REGION - ${region.subRegionName}`}</div>
                        <div style={{height:5}}></div>
                        <input style={{width:"100%", paddingLeft:5}} onChange={(event)=> {inputSelectChange(event);svvalueInput(inputSensitive.current.value)}} ref={inputSensitive} placeholder="Buscar ..." value={valueInput}/>
                        <div style={{height:5}}></div>
                        <div style={{textAlign:"center", fontWeight:"bold"}}>  Líneas Estratégicas - Plan de Desarrollo Departamental</div>
                      

                        {
                            initiativs.map((item, index) => (
                                <Link onClick={() => initiativeClick(item)} to={"/iniciativa/formulario1/formulario2/"} className="row m-0 align-items-center lineTextOver" style={{cursor:"pointer"}} key={item._id}>
                                    <div className="col-12 p-1 paragraphText"><strong>{`${item.priority}. `}</strong>{`${item.description}`}</div>
                                    {/*<div className="col-2 p-1 paragraphText" style={{textAlign:"center", fontWeight:"bold"}}>{item.priority}</div>*/}
                                </Link>
                            ))
                        }
                        {
                            valueInput === "" && <div className="row m-0 justify-content-center align-items-center" style={{userSelect:"none"}}> 
                                {
                                    currentPage > 1 && <FontAwesomeIcon color="#45a6dd" className="arrowPaging" icon={arrowLeft} style={{fontSize:30}} onClick={() => previousPage(-1)}/>
                                }
                                <div style={{marginLeft:10, fontSize:30}}>{currentPage}</div>
                                <div style={{fontSize:30}}>/</div>
                                <div style={{marginRight:10, fontSize:30}}>{totalPages}</div>
                                {
                                    currentPage < totalPages && <FontAwesomeIcon color="#45a6dd" className="arrowPaging" icon={arrowRight} style={{fontSize:30}} onClick={() => nextPage(1)}/>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
            <Footer/>
        </React.Fragment>
    )
}

export default InitiativeForm1;